import { SafeAnyType } from 'src/utils/safeAny';

export type StateFormEventType = 'change' | 'error';

export type StateFormFieldNamePathType = [formId: string, eventType: StateFormEventType, fieldName: string];

export const stateFormSubscriptions: Record<
  string,
  { change: Record<string, SafeAnyType>; error: Record<string, SafeAnyType> }
> = {};

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.stateForm = stateFormSubscriptions;
}
